import axios from '@/plugins/axios';

const VERIFY_EMAIL = '/verify-email';
const RE_SEND_EMAIL = '/send-email';
const CHECK_VALIDATE = '/check-register-validation';

export async function verifyEmailRegister(payload) {
  try {
    const { data } = await axios.get(`${VERIFY_EMAIL}/${payload.token}`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function reSendEmail(payload) {
  try {
    const { data } = await axios.post(`${RE_SEND_EMAIL}`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function checkValidate(payload) {
  try {
    const { data } = await axios.post(`${CHECK_VALIDATE}`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}
